
export { AuthenticatedAPI } from "/builds/t2_e_sw-P/2/dd3tech/wiggot/wiggot-web/packages/core-apis/src/apis/config/api/authenticatedApi.ts"
export { HttpRequestService } from "/builds/t2_e_sw-P/2/dd3tech/wiggot/wiggot-web/packages/core-apis/src/apis/config/httpService.ts"